import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { UpdateReviewPlatformPayload } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

interface UseUpdateReviewAnalysisPlatformMutationParams {
  onError?: () => void
  onSuccess?: () => void
}

export const useUpdateReviewAnalysisPlatformMutation = (
  campaignId: string,
  { onError, onSuccess }: UseUpdateReviewAnalysisPlatformMutationParams = {}
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      cardId,
      payload,
    }: {
      cardId: string
      payload: UpdateReviewPlatformPayload
    }) =>
      ReviewAnalysisApiService.updateReviewPlatform(
        campaignId,
        cardId,
        payload
      ),
    onError: () => {
      onError?.()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_OVERVIEW, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_STATUS, campaignId],
      })
      queryClient.invalidateQueries({
        queryKey: [QueryKey.GET_REVIEW_ANALYSIS_CAMPAIGN, campaignId],
      })
      onSuccess?.()
    },
  })
}
